import React, { useContext } from "react";
import { Button, Container, Flex, Heading, Input, Modal, Text } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../contexts/i18nContext";

function CreateGroupPopup(props) {
  const { t } = useContext(I18nContext);
  const { groupPopupVisible, closeGroupPopup, createGroup, groupName, setGroupName, selectedGroupData } = props;

  return (
    <Modal size="lg" isOpen={groupPopupVisible} className="locDeletePopup">
      <Flex direction="vertical" gap={16}>
        <Heading>{t("hierarchy-nodes.create-group-text")}</Heading>
        <Heading size="sub-section">{t("hierarchy-nodes.select-and-add-location-to-own-group-text")}</Heading>
        <Flex direction="vertical" gap={8}>
          <Input value={groupName} onChange={(e) => setGroupName(e.target.value)} placeholder={t("hierarchy-nodes.enter-group-name-text")} label={t("hierarchy-nodes.group-name-text")} />
          <Container style={{ maxHeight: "200px", overflowY: "scroll" }}>
            <Text size="p3" weight="semi-bold" style={{ marginBottom: "16px" }}>
              {selectedGroupData?.length} Selected
            </Text>
            {selectedGroupData &&
              selectedGroupData.length > 0 &&
              selectedGroupData.map((group) => {
                return (
                  <Text style={{ paddingTop: "8px" }} key={group?.id}>
                    {group?.name}
                  </Text>
                );
              })}
          </Container>
        </Flex>

        <Flex justify="flex-end" style={{ width: "100%", marginTop: 16 }}>
          <Button.Group className="modal-footer">
            <Button kind="tertiary" onClick={closeGroupPopup}>
              {t("business-location-details.cancel-text")}
            </Button>
            <Button onClick={createGroup}>{t("hierarchy-nodes.save-text")}</Button>
          </Button.Group>
        </Flex>
      </Flex>
    </Modal>
  );
}

export default CreateGroupPopup;
